import { render, staticRenderFns } from "./PromoCreationExpiration.vue?vue&type=template&id=34ea190a"
import script from "./PromoCreationExpiration.vue?vue&type=script&lang=js"
export * from "./PromoCreationExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports